import { trpc } from "../../lib/trpc.js";

export function useAuth() {
  const { data, isLoading, refetch } = trpc.auth.me.useQuery(undefined, {
    retry: false,
    staleTime: 5 * 60_000,
  });

  return {
    usuario: data ?? null,
    autenticado: data != null,
    papel: data?.role ?? null,
    ehAdmin: data?.role === "admin",
    carregando: isLoading,
    recarregar: refetch,
  };
}
